import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "Jesus Just Us — Christian community for prayer, testimonies, and worship";
const DEFAULT_DESCRIPTION =
  "A quiet, beautiful place to share testimonies, lift prayer, watch faith films, and walk with believers. One faith. One family. One mission.";
const SITE_NAME = "Jesus Just Us";
const SITE_URL = "https://jesusjustus.us";

/**
 * Per-page SEO + Open Graph + Twitter card. Drop <Seo title="..." description="..." />
 * at the top of any route to give it a unique <head>. Wrapped in <HelmetProvider/>
 * at app root.
 */
export default function Seo({
  title,
  description,
  path,
  image,
  noindex = false,
}) {
  const finalTitle = title ? `${title}` : DEFAULT_TITLE;
  const finalDescription = description || DEFAULT_DESCRIPTION;
  const url = path ? `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}` : SITE_URL;
  const ogImage = image || `${SITE_URL}/og-default.jpg`;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
